import {
  isAutreSituationProValue,
  isSituationProListField,
  isSituationProPrecisionField,
  normalizeChampNomKey,
  precisionFieldNameForSituationPro,
  sortProduitChampsForDisplay,
} from "@/lib/produitChampsForm";
import { formatPhoneForDisplay } from "@/lib/phoneFormat";

function dossierCustomFields(dossier) {
  return dossier?.custom_fields && typeof dossier.custom_fields === "object" && !Array.isArray(dossier.custom_fields)
    ? dossier.custom_fields
    : {};
}

/** Valeur d’un champ qualification (clé exacte ou normalisée). */
export function getQualificationFieldValue(dossier, champNom) {
  const cf = dossierCustomFields(dossier);
  if (!champNom) return undefined;
  if (Object.prototype.hasOwnProperty.call(cf, champNom)) return cf[champNom];
  const want = normalizeChampNomKey(champNom);
  for (const [k, v] of Object.entries(cf)) {
    if (normalizeChampNomKey(k) === want) return v;
  }
  return undefined;
}

function displayChampValue(dossier, nom, raw) {
  if (raw == null || raw === "") return null;
  if (typeof raw === "boolean") return raw ? "Oui" : "Non";
  const s = String(raw).trim();
  if (!s) return null;
  if (isSituationProListField(nom) && isAutreSituationProValue(s)) {
    const precNom = precisionFieldNameForSituationPro(nom);
    const prec = precNom ? getQualificationFieldValue(dossier, precNom) : null;
    if (prec != null && String(prec).trim() !== "") {
      return `Autre — ${String(prec).trim()}`;
    }
  }
  if (/t[ée]l[ée]phone|phone/i.test(String(nom))) {
    return formatPhoneForDisplay(s);
  }
  return s;
}

function champHasValue(dossier, nom) {
  const raw = getQualificationFieldValue(dossier, nom);
  if (raw == null || raw === "") return false;
  if (typeof raw === "boolean") return true;
  return String(raw).trim() !== "";
}

function isDeptChampNom(nom) {
  const nk = normalizeChampNomKey(nom);
  return nk === "departement" || nk.includes("departement");
}

/**
 * Lignes « Qualification » publiques pour aperçu marketplace (survol).
 */
export function buildPublicQualificationRows(dossier, produit, options = {}) {
  if (!dossier) return [];
  const { hideDeptDuplicate = false, maxRows = 14, showEmpty = false } = options;
  const typeDossier = dossier.type || "vente";
  const cibleAnnonce = (c) => {
    const ca = c.cible_annonces;
    if (ca == null || ca === "tous") return true;
    return ca === typeDossier;
  };

  let champs = [];
  if (produit?.champs?.length) {
    champs = sortProduitChampsForDisplay(
      produit.champs
        .filter(cibleAnnonce)
        .filter((c) => c.visible_public !== false)
        .filter((c) => !isSituationProPrecisionField(c.nom))
        .filter((c) => !(hideDeptDuplicate && isDeptChampNom(c.nom))),
      { produitNom: produit.nom },
    );
  }

  const rows = [];
  for (const c of champs) {
    const raw = getQualificationFieldValue(dossier, c.nom);
    const val = displayChampValue(dossier, c.nom, raw);
    if (!showEmpty && !champHasValue(dossier, c.nom)) continue;
    if (!showEmpty && val == null) continue;
    rows.push({ nom: c.nom, val: val ?? "—" });
    if (rows.length >= maxRows) break;
  }

  if (rows.length > 0) return rows;

  const cf = dossierCustomFields(dossier);
  const privateKeys = new Set([
    "nom du client",
    "telephone du client",
    "tel du client",
    "adresse du client",
    "adresse client",
  ]);
  for (const [k, raw] of Object.entries(cf)) {
    const nk = normalizeChampNomKey(k);
    if (privateKeys.has(nk)) continue;
    if (isSituationProPrecisionField(k)) continue;
    const val = displayChampValue(dossier, k, raw);
    if (val == null) continue;
    rows.push({ nom: k, val });
    if (rows.length >= maxRows) break;
  }
  return rows;
}
